export default "__VITE_ASSET__7908b99d__"